import * as types from "./constants";
import {
    getListComment,
    getDetailComment,
    apiCountNotificationNotRead,
    apiListError,
    apiHelpGetVideo,
    apiListHelp
} from "./api";

let yOffsetCurr;

const setLoading = ({ commit }, data) => {
    commit(types.SET_LOADING, data);
};

const setDocPreviewContent = ({ commit }, data) => {
    commit(types.SET_DATA_PREVIEW, data);
};

const setDocPreviewSlider = ({ commit }, data) => {
    commit(types.SET_DOC_SLIDER_DATA, data);
};

const toggleModalPreview = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_PREVIEW_DOC, data);
};

// const validateQuestion = ({ commit }, data) => {
//     return commit(types.VALIDATE_QUESTION, data);
// }

// Comments
const actionListHelp = ({ commit }, params = {}) => {
    return apiListHelp(params).then(res => {
        let data = res && !res.errors && res.data ? res.data : []
        commit(types.SET_LIST_HELP, data);
        return res;
    }).catch((error) => {
        return [];
    });
};
const actionHelpGetVideo = (context, id) => {
    return apiHelpGetVideo(id).then((response) => {
            context.commit('GET_HELP_VIDEO', response.data.data);
            return response;
        })
        .catch(({ response }) => {
            if (response && response.data) {
                context.commit('SET_ERROR', response.data.errors);
            }
        });
};
const getComment = ({ commit }, params = {}) => {
    return getDetailComment(params)
        .then((res) => {
            let data = res && !res.errors && res.data ? res.data : {};
            commit(types.SET_COMMENT_DETAIL, data);
            return data;
        })
        .catch((e) => {
            return false;
        });
};
const actionListError = ({ commit }, params = {}) => {
    return apiListError(params)
        .then((res) => {
            let data = res && !res.errors && res.data ? res.data : {};
            commit(types.SET_COMMENT_DETAIL, data);
            return data;
        })
        .catch((e) => {
            return false;
        });
};

const getComments = ({ commit }, params) => {
    return getListComment(params)
        .then((res) => {
            if (res && !res.errors && res.data) {
                let dataList = res.data.list ? res.data.list : [];
                let dataPaging = res.data.paging ? res.data.paging : {};
                commit(types.SET_COMMENT_LIST, dataList);
                commit(types.SET_PAGING_COMMENT, dataPaging);
            }
        })
        .catch((e) => {
            return false;
        });
};

const actionCountNotificationNotRead = (context) => {
    return apiCountNotificationNotRead()
        .then((response) => {
            context.commit(types.GET_COUNT_NOTIFI_NOT_RED, response.data.data);
            return response;
        })
        .catch(({ response }) => {
            if (response && response.data) {
                // context.commit('SET_ERROR', response.data.errors);
            }
        });
};

const actionCheckPage = ({ commit }, data) => {
    commit(types.CHECK_PAGE_EXCERCISE, data);
};

const actionCheckInfoExcercise = ({ commit }, data) => {
    commit(types.CHECK_INFO_EXCERCISE, data);
};

const actionCheckSlideActiveBook = ({ commit }, data) => {
    commit(types.CHECK_SLIDE_ACTIVE_BOOK, data);
};

const actionCheckArraySlide = ({ commit }, data) => {
    commit(types.CHECK_ARRAY_SLIDE, data);
};

const actionSetBookPageLinkId = ({ commit }, data) => {
    commit(types.SET_BOOK_PAGE_LINK_ID, data);
};

const actionSetPageNoBook = ({ commit }, data) => {
    commit(types.SET_PAGE_NO_BOOK, data);
};

const actionSetBookIndexId = ({ commit }, data) => {
    commit(types.SET_BOOK_INDEX_ID, data);
};

const actionSetBookIdForError = ({ commit }, data) => {
    commit(types.SET_BOOKID_FOR_ERROR, data);
};

const setParamSearchComments = ({ commit }, data) => {
    commit(types.SET_PARAM_SEARCH_COMMENTS, data);
};

const setParamSearchCommentDetail = ({ commit }, data) => {
    commit(types.SET_PARAM_SEARCH_COMMENT, data);
};

const setPagingComments = ({ commit }, data) => {
    commit(types.SET_PAGING_COMMENT, data);
};

const setDataDetailNotifi = ({ commit }, data) => {
    commit(types.SET_DATA_DETAIL_NOTIFI, data);
};

const actionDisplayNotification = ({ commit }, data) => {
    commit(types.SET_PARAM_DISPLAY, data);
};

const setCommentDetail = ({ commit }, data) => {
    commit(types.SET_COMMENT_DETAIL, data);
};

const setCommentList = ({ commit }, data) => {
    commit(types.SET_COMMENT_LIST, data);
};

const setDrawShapeData = ({ commit }, data) => {
    commit(types.DRAW_DATA, data);
};

const setActionCheckQuestion = ({ commit }, data) => {
    commit(types.ACTION_CHECK_CORRECT_QUESTION, data);
};

const toggleDrawTool = ({ commit }, data) => {
    if (data) {
        yOffsetCurr = window.pageYOffset;
        document.body.classList.add("open-draw");
        window.scrollTo(0, 0);
    } else {
        document.body.className = document.body.className.replace("open-draw", "");
        window.scrollTo(0, yOffsetCurr);
    }
    commit(types.TOGGLE_DRAW_SHAPE_TOOL, data);
};

const actionSetCountView = ({ commit }, data) => {
    commit(types.ACTION_SET_COUNT_VIEW, data);
};

const setToggleGuideActiveBook = ({ commit }, data) => {
    commit(types.TOGGLE_GUIDE_ACTIVE_BOOK, data);
};

const setToggleModalActivePage = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_ACTIVE_PAGE, data);
};

const setIdActiveBookInHeader = ({ commit }, data) => {
    commit(types.SET_ID_ACTIVE_CODE_BOOK_HEADER, data);
};

const setToggleModalDocSlider = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_DOC_SLIDER, data);
};

const acToggleModalActiveBook = ({ commit }, toggle) => {
    commit(types.TOGGLE_MODALACTIVE_BOOK, toggle);
};

const acSetDataBookActiveWant = ({ commit }, data) => {
    commit(types.SET_BOOK_ACTIVE_WANT, data);
};

const acBookIdActiveSuccess = ({ commit }, data) => {
    commit(types.SET_BOOK_ID_ACTIVE_SUCCESS, data);
};

const acToggleModalShareMedia = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_SHARE, data);
};

const acSetMediaShareInfo = ({ commit }, data) => {
    commit(types.SET_INFO_MEDIA_SHARE, data);
};

const acToggleModaShowError = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_SHOW_ERROR, data);
};

const acToggleModaShowHelp = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_SHOW_HELP, data)
}

const acToggleModalShowNotify = ({ commit }, data) => {
    commit(types.TOGGLE_MODAL_SHOW_NOTIFY, data)
}


const actionSetIdDetaiHelp = ({ commit }, data) => {
    commit(types.SET_ID_DETAIL_HELP, data)
}

const actionCheckRouterHelp = ({ commit }, data) => {
    commit(types.SET_ROUTER_HELP, data)
}

const actionGetVideoHelp = ({ commit }, data) => {
    commit(types.GET_SHOW_VIDEO_HELP, data)
}

const actionSetQuestionId = ({ commit }, data) => {
    commit(types.SET_QUESTION_ID, data)
}
const actionSetInfoLibrary = ({ commit }, data) => {
    commit(types.SET_INFO_LIBRARY, data)
}
const actionGetBookId = ({ commit }, data) => {
    commit(types.GET_BOOK_ID, data)
}

const actionSetDataModalNoti = ({ commit }, data) => {
    commit(types.SET_DATA_MODAL_NOTI, data)
}


export default {
    setLoading,
    setDocPreviewContent,
    toggleModalPreview,
    // validateQuestion,
    getComments,
    getComment,
    setParamSearchComments,
    setParamSearchCommentDetail,
    setPagingComments,
    setCommentDetail,
    setCommentList,
    setDrawShapeData,
    setActionCheckQuestion,
    toggleDrawTool,
    setToggleGuideActiveBook,
    setIdActiveBookInHeader,
    setToggleModalActivePage,
    setDocPreviewSlider,
    setToggleModalDocSlider,
    acToggleModalActiveBook,
    acSetDataBookActiveWant,
    acBookIdActiveSuccess,
    acToggleModalShareMedia,
    acSetMediaShareInfo,
    actionCountNotificationNotRead,
    setDataDetailNotifi,
    actionDisplayNotification,
    actionListError,
    acToggleModaShowError,
    actionSetIdDetaiHelp,
    actionCheckRouterHelp,
    acToggleModaShowHelp,
    actionHelpGetVideo,
    actionListHelp,
    actionGetVideoHelp,
    actionSetBookIdForError,
    actionSetBookIndexId,
    actionSetPageNoBook,
    actionSetBookPageLinkId,
    actionSetQuestionId,
    actionSetInfoLibrary,
    actionGetBookId,
    actionSetCountView,
    actionCheckPage,
    actionCheckSlideActiveBook,
    actionCheckArraySlide,
    acToggleModalShowNotify,
    actionSetDataModalNoti,
    actionCheckInfoExcercise
};